import { Outlet } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { CategoriesDataTable } from 'modules/trainings/components/CategoriesDataTable'

export default function Categories() {
  const { navigation } = useNavigation()
  return (
    <ResponsivePage.Body
      showHeader={false}
      actions={{
        primary: [
          {
            icon: 'settings',
            to: navigation.settings.trainings.fullPath(),
            label: '',
            variant: 'secondary',
          },
        ],
      }}
    >
      <CategoriesDataTable />
      <Outlet />
    </ResponsivePage.Body>
  )
}
